module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"Verification System"},"ja":{"hello":"手続きシステム"}}')
  delete Component.options._Ctor
}
